<template>
    <div style="margin-right:10px;" >
        <el-button :disabled="canClick" size="mini" type="primary" @click="batchDownload" icon="el-icon-download">一键下载</el-button>
    </div>
</template>
<script>
import JSZip from "jszip";
import FileSaver from "file-saver";
import { getStorage } from "@/util/localStor";
export default {
    props:{
        fileList:{
            type:Array,
            default:function() {
              return []; 
            }
        },
        name:{
            type:String,
            default:''
        },
        canClick:{
            type:Boolean,
            default:false
        },
        downType:{
          type:Number,
          default:1
        }
    },

    methods:{
        batchDownload() {
          var blogTitle = ``
          let fileList = this.fileList || []
          if(this.downType==1){
            blogTitle = `索赔单_${this.name}`;
          }else{
            blogTitle = `质量反馈问题序号_${this.name}`;
            let inspectRecordList = Object.values(getStorage('inspectRecordFile'))
            let arr1  = []
            inspectRecordList.map(item=>{
              if(item.inspectRecordFileList.length>0&&item.inspectRecordFileList!=null)arr1.push(...item.inspectRecordFileList)
            })
            let auditList = Object.values(getStorage('auditFile'))
            
            let arr  = []
            auditList.map(item=>{
              if(item.auditFileList.length>0&&item.auditFileList!=null)arr.push(...item.auditFileList)
            })
            fileList = [...fileList,...arr1,...arr]
            if(fileList.length<=0){
              this.$DonMessage.warning('当前问题单无附件');
              return
            }
          }
          var zip = new JSZip();
          var promises = [];
          let cache = {};
          for (let item of fileList) {
            if (item.filePath) {
              const promise = this.getImgArrayBuffer(item.filePath).then((data) => {
                // 下载文件, 并存成ArrayBuffer对象(blob)
                zip.file(item.fileName, data, { binary: true }); // 逐个添加文件
                cache[item.fileName] = data;
              });
              promises.push(promise);
            } else {
              // url地址不存在时提示
              this.$DonMessage.warning(`附件${item.fileName}地址错误，下载失败`);
         
            }
          }
          Promise.all(promises)
            .then(() => {
              zip.generateAsync({ type: "blob" }).then((content) => {
                // 生成二进制流
                FileSaver.saveAs(content, blogTitle); // 利用file-saver保存文件  blogTitle:自定义文件名
              });
            })
            .catch((res) => {
              this.$DonMessage.warning("文件压缩失败");
            });
        },
        //文件以流的形式获取（参数url为文件链接地址）
        getImgArrayBuffer(url) {
          return new Promise((resolve, reject) => {
            //通过请求获取文件blob格式
            let xmlhttp = new XMLHttpRequest();
            xmlhttp.open("GET", url, true);
            xmlhttp.responseType = "blob";
            xmlhttp.onload = function () {
              if (xmlhttp.status == 200) {
                resolve(xmlhttp.response);
              } else {
                reject(xmlhttp.response);
              }
            };
            xmlhttp.send();
          });
        },

    }
}
</script>